/*
* @flow
* @author : Dinesh
*/

import { observable } from 'mobx'

class LineGraphValue {
  @observable y: number
  @observable marker: string

  constructor(y: number, marker?: string = '') {
    this.y = y
    this.marker = marker
  }
}

export default LineGraphValue
